import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BorrowingsService {
  URL = this.ConfigService.getAPIBaseUrl() + 'api/Borrowings/';

  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveBorrowings(InsertBorrowings) {
    debugger;
    return this.HttpClient.post(this.URL + 'InsertBorrowings', InsertBorrowings)
  }

  GetOneBorrowings(APPeriodid) {
    debugger;
    return this.HttpClient.get(this.URL + "GetOneBorrowings?APPeriodid=" + APPeriodid)
  }
  GetOneBorrowings_LY(APPeriodid) {
    debugger;
    return this.HttpClient.get(this.URL + "GetOneBorrowings_LY?APPeriodid=" + APPeriodid)
  }
}
